<template>
  <div>
    <div class="theme_box" ref="content" :class="{ expanded: isExpanded }" v-if="themeList.length">
      <div class="theme_one" v-for="(item, index) in themeList" :key="index">
        <!-- 左侧头像 -->
        <div class="theme_avatar">
          <el-image class="avatar" :src="iconPath(item.buyerUserHeadImage)"></el-image>
        </div>
        
        <!-- 右侧主内容区域 -->
        <div class="theme_main">
          <!-- 头部：用户名 + 时间 -->
          <div class="theme_header">
            <div class="theme_name">{{ item.buyerUserName }}</div>
            <div class="theme_time">{{ item.updateTime }}</div>
          </div>
          
          <!-- 内容区域 -->
          <div class="theme_content_wrapper">
            <div class="theme_content">{{ item.content }}</div>
          </div>
          
          <!-- 底部：课程来源 + 操作按钮 -->
          <div class="theme_footer">
            <div class="theme_source_info">
              <span class="theme_source toverflow">来自课程：{{ item.sceneDiscuss?.courseName || item.sceneAppraise?.courseName }}</span>
            </div>
            
            <div class="theme_actions">
              <div class="action_item" @click="replyToTheme(item)">
                <el-image class="action_icon" :src="imgPath('reply_icon.png')"></el-image>
                <span class="action_count">{{ item.replyNum || 0 }}</span>
              </div>
              <div class="action_item" @click="cancelLiked(item, item.isLiked ? 'disliked' : 'liked')">
                <el-image 
                  class="action_icon" 
                  :src="imgPath(item.isLiked ? 'liked_icon.png' : 'like_icon.png')"
                ></el-image>
                <span class="action_count">{{ item.likeNum || 0 }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <moe-empty url="moe_empty_bg_img.png" emptyText="暂无回复"></moe-empty>
    </div>
  </div>
</template>

<script>
export default {
  name: "GjkcH5Reply",

  data() {
    return {
      themeList: [],
      isExpanded: false,
      showLoadMore: false,
    };
  },

  watch: {
    items: {
      immediate: true,
      handler() {
        // this.$nextTick(this.checkOverflow);
      },
    },
  },

  mounted() {
    // this.checkOverflow();
  },

  methods: {
    checkOverflow() {
      if (!this.$refs.content) return;
      this.showLoadMore =
        this.$refs.content.scrollHeight > this.$refs.content.clientHeight;
    },
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },
    
    // 回复
    replyToTheme(item) {
      this.$emit("reply", item);
    },
    
    // 取消点赞
    cancelLiked(info, type) {
      let cancelQuery = {
        courseId: info.courseId,
        scene: 3,
        sceneId: info.replyId,
      };
      this.$Api.course
        .evaluateLike(cancelQuery)
        .then(() => {
          if (type == 'disliked') {
            this.$Dialog.toast("已取消点赞");
          } else {
            this.$Dialog.toast("点赞成功");
          }
          this.$emit("changeTab");
        })
        .catch(() => { });
    },
  },
};
</script>

<style lang="scss" scoped>
.theme_box {
  .theme_one {
    display: flex;
    padding: 20px 0;
    border-bottom: 1px solid rgba(20, 20, 20, 0.08);
    
    &:last-child {
      border-bottom: none;
    }
    
    // 左侧头像
    .theme_avatar {
      flex-shrink: 0;
      margin-right: 15px;
      
      .avatar {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        object-fit: cover;
      }
    }
    
    // 右侧主内容
    .theme_main {
      flex: 1;
      min-width: 0;
      
      // 头部：用户名 + 时间
      .theme_header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        
        .theme_name {
          font-size: 14px;
          font-weight: 500;
          color: #999999;
        }
        
        .theme_time {
          font-size: 12px;
          color: #bbbbbb;
          white-space: nowrap;
          margin-left: 12px;
        }
      }
      
      // 内容区域
      .theme_content_wrapper {
        margin-bottom: 12px;
        
        .theme_content {
          font-size: 15px;
          line-height: 1.5;
          color: #333333;
          word-break: break-word;
        }
      }
      
      // 底部：来源 + 操作
      .theme_footer {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 12px;
        
        .theme_source_info {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          gap: 4px;
          font-size: 12px;
          color: #909090;
          
          .theme_source {
            max-width: 200px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }
        
        .theme_actions {
          display: flex;
          align-items: center;
          gap: 20px;
          
          .action_item {
            display: flex;
            align-items: center;
            gap: 6px;
            cursor: pointer;
            transition: opacity 0.2s;
            
            &:hover {
              opacity: 0.7;
            }
            
            .action_icon {
              width: 20px;
              height: 20px;
            }
            
            .action_count {
              font-size: 12px;
              color: #999999;
            }
          }
        }
      }
    }
  }
}

.theme_box.expanded {
  max-height: none;
  overflow: visible;
}

.more_load {
  width: 200px;
  height: 35px;
  background: #f5f6f8;
  border-radius: 8px;
  line-height: 35px;
  text-align: center;
  margin: 10px auto;
  cursor: pointer;
  
  &:hover {
    background: #e8e8e8;
  }
}
</style>